import Seo from "@/components/Seo";
import Hero from "@/components/landing/Hero";
import TrustStrip from "@/components/landing/TrustStrip";
import Manifesto from "@/components/landing/Manifesto";
import Marquee from "@/components/landing/Marquee";
import Pathways from "@/components/landing/Pathways";
import Apparitions from "@/components/landing/Apparitions";
import TodayWithMary from "@/components/landing/TodayWithMary";
import LearnAndPray from "@/components/landing/LearnAndPray";
import Invitation from "@/components/landing/Invitation";
import { SITE_AFFILIATION } from "@/data/editorial";

const JSON_LD = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Theotokos · Mater Dei",
  description:
    `${SITE_AFFILIATION} Dedicated to the Blessed Virgin Mary: apparitions, shrines, prayers, feasts, and teaching — Latin and Eastern.`,
};

export default function Home() {
  return (
    <main data-testid="home-page">
      <Seo
        title="Theotokos · Mater Dei — A Catholic Treasury of Our Lady"
        siteName="Theotokos · Mater Dei"
        description="Explore a Catholic treasury of Scripture, prayer, Marian apparitions, shrines, feasts, saints, and devotion from around the world — faithful to the Church, clearly sourced, prayerfully presented."
        image="/emblem-512.png"
        jsonLd={JSON_LD}
      />
      <Hero />
      <TrustStrip />
      <Manifesto />
      <Marquee />
      <Pathways />
      <Apparitions />
      <TodayWithMary />
      <LearnAndPray />
      <Invitation />
    </main>
  );
}
